import React, { useEffect, useRef, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

import { HeroDefault } from '../components/default-sections/Hero';

import SnippetCard from '../components/main/SnippetMenu';
import CodeEditor from "../components/main/CodeEditor";

import { auth } from "../auth/firebase/Firebase";
import { fetchUserName, addSnippet } from "../auth/firebase/snippets/Controller";

import "../assets/css/CreateSnippet.css"
const javascriptDefault = ``;

function CreateSnippet() {
  const [code, setCode] = useState(javascriptDefault);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [howitworks, setHowItWorks] = useState("");

  const [snippetMessage, setSnippetMessage] = useState("");
  const [hiddenMessage, setHiddenShowMessage] = useState(true);

  const tagInput = useRef();
  const [tags, setTags] = useState([]);

  const [user, loading] = useAuthState(auth);
  const [language, setLanguage] = useState("Javascript");
  const [name, setName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");

    if (!name) {
      fetchUserName(user)
        .then((name) => {
          setName(name);
        })
    }
  }, [user, loading, name, navigate]);

  const submitCode = async () => {
    addSnippet(name, {  title: title, 
                        description: description, 
                        howitworks: howitworks, 
                        code: code, 
                        language: language, 
                        tags: tags })
    setSnippetMessage("Your snippet has been created!");
    setHiddenShowMessage(false);
    setTimeout(() => {
      setSnippetMessage("");
      setHiddenShowMessage(true);
      clearFields();
    }, 3000);

  }

  const clearFields = () => {
    window.location.reload(false);
  }

  const tagHandler = () => {
    let tag = tagInput.current.value;
    setTags((prevTags) => [
      ...prevTags, tag,
    ]);
    tagInput.current.value = "";
  }

  const removeTag = (tagValue) => {
    const newTags = tags.filter((tag) => tag !== tagValue);
    setTags(newTags);
  }

  const onChange = (action, data) => {

    switch (action) {
      case "code": {
        setCode(data);
        break;
      }
      default: {
        console.warn("case not handled!", action, data);
      }
    }
  };

  const createForm = () => {
    return (
      <>
        <div className="form-message" hidden={hiddenMessage}>{snippetMessage}</div>
        <div className="mb-3">
          <button type="button" className="btn btn-primary submit-btn" onClick={() => { submitCode() }}>Submit</button>
        </div>
        <div className="mb-3">
          <div className="dropdown">
            <button className="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              Language ({language})
            </button>

            <ul className="dropdown-menu">
              <li><button className="dropdown-item" onClick={() => setLanguage("Javascript")}>Javascript</button></li>
              <li><button className="dropdown-item" onClick={() => setLanguage("Typescript")}>Typescript</button></li>
              <li><button className="dropdown-item" onClick={() => setLanguage("HTML")}>HTML</button></li>
              <li><button className="dropdown-item" onClick={() => setLanguage("C##")}>C##</button></li>
              <li><button className="dropdown-item" onClick={() => setLanguage("C+")}>C+</button></li>
              <li><button className="dropdown-item" onClick={() => setLanguage("Python")}>Python</button></li>
            </ul>
          </div>
        </div>
        <div className="mb-3">
          <input type="text" className="form-control" id="snippet-title" value={title} onChange={event => setTitle(event.target.value)} placeholder="Title ..." />
        </div>
        <div className="mb-3">
          <textarea className="form-control" id="snippet-description" rows="3" placeholder="Description"
            value={description} onChange={event => setDescription(event.target.value)}></textarea>
        </div>
        <div className="mb-3">
          <textarea className="form-control" id="snippet-description" rows="3" placeholder="How It Works"
            value={howitworks} onChange={event => setHowItWorks(event.target.value)}></textarea>
        </div>
        <div className="row mb-3">
          <div className="col-md-10">
            <label htmlFor="inputPassword2" className="visually-hidden">Password</label>
            <input type="text" className="form-control" id="inputPassword2" placeholder="Tag" ref={tagInput} />
          </div>
          <div className="col-md-2">
            <button type="submit" className="btn btn-primary" onClick={() => tagHandler()}>Add Tag</button>
          </div>
        </div>
        <div className="tag-cotainer mb-3">
          {tags && tags.length > 0 ? (
            tags.map((t) =>
              <span className="badge text-bg-info tag-spacing" onClick={() => removeTag(t)}>{t}</span>
            )
          ) : ("")
          }
        </div>
        <div className="mb-3">
          <CodeEditor
            code={code}
            onChange={onChange}
            theme={"cobalt"}
            language={language}
          />
        </div>
      </>
    );
  }

  return (
    (!loading ? (
      <>
        <HeroDefault
          header="Create Snippet"
          content={createForm()}
        />
        <SnippetCard user={user} />
      </>
    ) : (""))
  );
}
export default CreateSnippet;


